/**
 * 用户相关路由
 */
export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index.vue")
  },
  {
    path: "/regis_enterprise",
    name: "registerEnterprise",
    component: () => import("@/views/register/_enterprise.vue")
  },
  {
    path: "/regis_person",
    name: "registerPerson",
    component: () => import("@/views/register/_person.vue")
  }
];
